export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_q01_b.340551fa.png";